<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
//  import {setDefault} from './assets/js/common/themeFunction'
import {getDeviceStatus,getDev,writeAppLog,getLastMsg} from './assets/js/deviceOperate'


export default {
  name: 'app',
    methods:{
        deviceEventCallBack:function (DeviceID, UserEvtID, RetCode, RetMsg) {
            this.$bus.emit('deviceCallBack', DeviceID,UserEvtID,RetCode,RetMsg);
        },

        deviceCallBack:function (DeviceID, UserEvtID, RetCode, RetMsg) {

//           writeAppLog(4,"父页面接收到事件，事件DeviceId:"+DeviceID);
            if(DeviceID==1000)
            {
                this.GlobalConfig.APP_CONFIG.CALL_BACK_FLAG=true;
            }


        }
    },
    created () {
        this.$bus.on('deviceCallBack', this.deviceCallBack);
        try {
            let result=getDev().TestEvent(100,"test");
            writeAppLog(4,"调用TestEvent结果："+result);
            if(result==0)
            {
                this.GlobalConfig.APP_CONFIG.TEST_EVENT_FLAG=true;
            }

        }
        catch(e) {
            this.GlobalConfig.APP_CONFIG.TEST_EVENT_FLAG=false;
        }
    },
    beforeDestroy () {
        this.$bus.off('deviceCallBack', this.deviceCallBack);
    },
    mounted:function () {
//        setDefault("purple");
        //注册网页控件
        // setCallBackFun(this.deviceEventCallBack);



    }
}
</script>

<style>
#app {

}




</style>



// WEBPACK FOOTER //
// src/App.vue